import { Button } from "@devhop/ui";
import { PlusIcon, UserCogIcon } from "lucide-react";

type OutsourceToolbarProps = {
  canManage?: boolean;
  onCreate: () => void;
  onBulkFromStaff?: () => void;
  onManageCategories?: () => void;
  onManageApPlans?: () => void;
};

export function OutsourceToolbar({
  canManage,
  onCreate,
  onBulkFromStaff,
  onManageCategories,
  onManageApPlans,
}: OutsourceToolbarProps) {
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">Outsource (KOL/Media)</h2>
        <p className="text-muted-foreground text-sm">
          Master ຜູ້ຮັບ KOL / media / vendor — ດຶງໃຊ້ໃນ Event roster ໄດ້
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        {onManageCategories ? (
          <Button variant="outline" onClick={onManageCategories}>
            ຫມວດ Outsource
          </Button>
        ) : null}
        {onManageApPlans ? (
          <Button variant="outline" onClick={onManageApPlans}>
            ແມ່ແບບງວດ AP
          </Button>
        ) : null}
        {canManage ? (
          <>
            {onBulkFromStaff ? (
              <Button variant="outline" onClick={onBulkFromStaff}>
                <UserCogIcon className="size-4" /> ດຶງ Staff ຫຼາຍຄົນ
              </Button>
            ) : null}
            <Button onClick={onCreate}>
              <PlusIcon className="size-4" /> ເພີ່ມ Outsource
            </Button>
          </>
        ) : null}
      </div>
    </div>
  );
}
